/**
 * Menu list / panel display helpers for sales mix GP chips — aligned with
 * app/utils/menuBuilderMenuGpChips.js.
 */

import { formatMarginPriceForDisplay } from 'src/utils/vatCalculations'

export const getMenuAvgGp = menu => {
  const avg = Number(menu?.averageGP)
  return Number.isFinite(avg) && avg > 0 ? Math.round(avg) : null
}

export const getMenuSalesMixDisplay = ({
  hasSalesMix = false,
  weightedGp = null,
  estimatedTotalGp = null,
} = {}) => {
  if (!hasSalesMix) {
    return {
      weightedGp: null,
      estimatedTotalGpLabel: null,
    }
  }

  return {
    weightedGp:
      weightedGp != null && Number.isFinite(Number(weightedGp))
        ? Math.round(Number(weightedGp))
        : null,
    estimatedTotalGpLabel:
      estimatedTotalGp != null
        ? formatMarginPriceForDisplay(estimatedTotalGp)
        : null,
  }
}

export const getMenuGpChipDisplay = (menu = {}) => {
  const salesMix = getMenuSalesMixDisplay(menu)

  return {
    avgGp: getMenuAvgGp(menu),
    weightedGp: salesMix.weightedGp,
    estimatedTotalGpLabel: salesMix.estimatedTotalGpLabel,
  }
}

/** Merge PATCH sales-mix menu payload onto a menus[] list item for card chips. */
export const mergeMenuListItemWithSalesMixPatch = (
  menu = {},
  savedMenu = {},
) => ({
  ...menu,
  ...savedMenu,
  hasSalesMix: savedMenu.hasSalesMix ?? menu.hasSalesMix,
  weightedGp:
    'weightedGp' in savedMenu ? savedMenu.weightedGp : menu.weightedGp,
  estimatedTotalGp:
    'estimatedTotalGp' in savedMenu
      ? savedMenu.estimatedTotalGp
      : menu.estimatedTotalGp,
  salesMix: savedMenu.salesMix ?? menu.salesMix,
  salesMixPeriod: savedMenu.salesMixPeriod ?? menu.salesMixPeriod,
})

/** Merge PATCH sales-mix payload onto currentMenu while keeping section data. */
export const mergeSavedMenuIntoCurrentMenu = (
  currentMenu = {},
  savedMenu = {},
) => ({
  ...currentMenu,
  ...savedMenu,
  sections: currentMenu.sections ?? savedMenu.sections,
  recipesBySection: currentMenu.recipesBySection ?? savedMenu.recipesBySection,
  hasSalesMix: savedMenu.hasSalesMix ?? currentMenu.hasSalesMix,
  weightedGp:
    'weightedGp' in savedMenu ? savedMenu.weightedGp : currentMenu.weightedGp,
  estimatedTotalGp:
    'estimatedTotalGp' in savedMenu
      ? savedMenu.estimatedTotalGp
      : currentMenu.estimatedTotalGp,
  salesMix: savedMenu.salesMix ?? currentMenu.salesMix,
  salesMixPeriod: savedMenu.salesMixPeriod ?? currentMenu.salesMixPeriod,
})
